import {type SetStateAction} from 'react';

export const stateUpdaterFn = <T>(state: SetStateAction<T>, prev: T) => {
	return typeof state === 'function' ? (state as (prev: T) => T)(prev) : state;
};
